type Props = {
  stats: Record<string, number>
  total: number
}

export function DocumentosStats({ stats, total }: Props) {
  if (total === 0) return null
  return (
    <section className='cf3-block cf3-doc-stats' aria-label='Resumo dos arquivos'>
      <p className='cf3-doc-stats__total'>
        {total} arquivo{total !== 1 ? 's' : ''} na obra
      </p>
      <div className='cf3-doc-stats__cats'>
        {Object.entries(stats)
          .sort(([, a], [, b]) => b - a)
          .map(([cat, count]) => (
            <span key={cat} className='cf3-doc-stats__chip'>
              {cat} <strong>{count}</strong>
            </span>
          ))}
      </div>
    </section>
  )
}
